export const VAULTS_BETA_MENU = [
  { path: '/vaults-beta', label: 'Vaults Beta' },
  { path: 'https://docs.yearn.fi/getting-started/products/yvaults/overview', label: 'Docs' },
  { path: 'https://discord.gg/yearn', label: 'Support', target: '_blank' },
  { path: 'https://blog.yearn.fi/', label: 'Blog', target: '_blank' },
  {
    path: 'https://gov.yearn.fi/',
    label: 'Discourse',
    target: '_blank'
  }
]
